document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('searchInputDropdown');
  const dropdown = document.getElementById('search-dropdown');
  const submitBtn = document.getElementById('searchsubmitBtn');

  input.addEventListener('input', (event) => {
    const sanitizedValue = event.target.value.replace(/[^a-zA-Z0-9\s]/g, '');
    if (event.target.value !== sanitizedValue) {
      event.target.value = sanitizedValue;
    }
    showDropdownSearch(input, dropdown);
  });
  input.addEventListener('click', () => showDropdownSearch(input, dropdown));
  submitBtn.addEventListener('click', handleSearch);
  document.addEventListener('click', (event) =>
    handleDocumentClick(event, input, dropdown),
  );
});

function showDropdownSearch(input, dropdown) {
  const filter = input.value.trim();

  if (filter.length > 0) {
    fetch(`${window._Torus.BFF_BASE_URL}/faqs/search?q=${filter}`)
      .then((response) => response.json())
      .then((data) => {
        const questions = data.data;

        updateDropdownOptions(questions, input, dropdown);
      })
      .catch((error) => {
        console.error('Error fetching search results:', error);
      });
  } else {
    dropdown.style.display = 'none';
  }
}

function updateDropdownOptions(options, input, dropdown) {
  dropdown.innerHTML = '';

  if (options.length === 0) {
    const noResultsDiv = document.createElement('div');
    noResultsDiv.textContent = 'Record not found';
    noResultsDiv.classList.add('no-result');
    noResultsDiv.style.color = 'grey';
    dropdown.appendChild(noResultsDiv);
  } else {
    options.forEach((option) => {
      const div = document.createElement('a');
      div.textContent = option.question;
      div.classList.add('dropdown-item');
      div.dataset.id = option.id;
      div.dataset.section = option.section;
      div.href = `${window.location.origin}/faqs/${option.category_slug}${option.subcategory_slug ? `/${option.subcategory_slug}` : ''}/${option.slug}-${option.id}`;

      dropdown.appendChild(div);
    });
  }

  dropdown.style.display = dropdown.innerHTML ? 'block' : 'none';
}

function handleSearch() {
  const input = document.getElementById('searchInputDropdown');
  moveCursorToEnd(input);
}

function moveCursorToEnd(input) {
  input.focus();
  input.setSelectionRange(input.value.length, input.value.length);
}

function handleDocumentClick(event, input, dropdown) {
  if (!input.contains(event.target) && !dropdown.contains(event.target)) {
    dropdown.style.display = 'none';
  }
}
